import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MarketingLayout } from './layouts/MarketingLayout';
import { AppLayout } from './layouts/AppLayout';
import { ScrollToTop } from './components/ScrollToTop';
// Marketing pages
import { HomePage } from './pages/HomePage';
import { ForArtistsPage } from './pages/ForArtistsPage';
import { ForVenuesPage } from './pages/ForVenuesPage';
import { ForAgentsPage } from './pages/ForAgentsPage';
import { ProductOverviewPage } from './pages/ProductOverviewPage';
import { PricingPage } from './pages/PricingPage';
import { DiscoveryRoutingPage } from './pages/DiscoveryRoutingPage';
import { DealsContractsPage } from './pages/DealsContractsPage';
import { LineupTourOpsPage } from './pages/LineupTourOpsPage';
import { AIAssistantPage } from './pages/AIAssistantPage';
import { SecurityPage } from './pages/SecurityPage';
import { DemoPage } from './pages/DemoPage';
import { ContactPage } from './pages/ContactPage';
import { ContactSalesPage } from './pages/ContactSalesPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { FAQPage } from './pages/FAQPage';
import { UseCasesHubPage } from './pages/UseCasesHubPage';
import { PlanRegionalTourPage } from './pages/use-cases/PlanRegionalTourPage';
import { FillOpenDatePage } from './pages/use-cases/FillOpenDatePage';
import { RunRosterPage } from './pages/use-cases/RunRosterPage';
import { LockLineupPage } from './pages/use-cases/LockLineupPage';
import { OfferToDepositPage } from './pages/use-cases/OfferToDepositPage';
import { ManageShowPage } from './pages/use-cases/ManageShowPage';
import { OperatePlainLanguagePage } from './pages/use-cases/OperatePlainLanguagePage';
// System pages
import { NotFoundPage } from './pages/NotFoundPage';
import { ForbiddenPage } from './pages/ForbiddenPage';
import { ServerErrorPage } from './pages/ServerErrorPage';
import { MaintenancePage } from './pages/MaintenancePage';
// Auth pages (standalone, no layout)
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { Setup2FAPage } from './pages/auth/Setup2FAPage';
import { WorkspaceSelectPage } from './pages/auth/WorkspaceSelectPage';
import { PlanSelectPage } from './pages/auth/PlanSelectPage';
import { CheckoutPage } from './pages/auth/CheckoutPage';
import { AccountProfilePage } from './pages/auth/AccountProfilePage';
import { AccountPreferencesPage } from './pages/auth/AccountPreferencesPage';
// Onboarding
import { OnboardingPage } from './pages/OnboardingPage';
// App pages
import { DashboardPage } from './pages/app/DashboardPage';
import { CampaignsPage } from './pages/app/CampaignsPage';
import { CampaignDetailPage } from './pages/app/CampaignDetailPage';
import { CampaignNewPage } from './pages/app/CampaignNewPage';
import { VenuesPage } from './pages/app/VenuesPage';
import { VenueDetailPage } from './pages/app/VenueDetailPage';
import { VenueProfilePage } from './pages/app/VenueProfilePage';
import { InboxPage } from './pages/app/InboxPage';
import { DealsPage } from './pages/app/DealsPage';
import { DealDetailPage } from './pages/app/DealDetailPage';
import { SchedulePage } from './pages/app/SchedulePage';
import { LineupPage } from './pages/app/LineupPage';
import { ShowsPage } from './pages/app/ShowsPage';
import { ShowDetailPage } from './pages/app/ShowDetailPage';
import { AnalyticsPage } from './pages/app/AnalyticsPage';
import { AssetsPage } from './pages/app/AssetsPage';
import { SettingsPage } from './pages/app/SettingsPage';
import { ArtistProfilePage } from './pages/app/ArtistProfilePage';
import { ContractsPage } from './pages/app/ContractsPage';
import { PaymentsPage } from './pages/app/PaymentsPage';
import { TeamPage } from './pages/app/TeamPage';
import { EventNeedsPage } from './pages/app/EventNeedsPage';
import { EventNeedDetailPage } from './pages/app/EventNeedDetailPage';
import { EventNeedNewPage } from './pages/app/EventNeedNewPage';
import { ArtistSearchPage } from './pages/app/ArtistSearchPage';
import { NotificationsPage } from './pages/app/NotificationsPage';
import { RosterPage } from './pages/app/RosterPage';
import { MemberDetailPage } from './pages/app/MemberDetailPage';
import { ContractTemplateBuilderPage } from './pages/app/ContractTemplateBuilderPage';
import { GeneratedDocumentDetailPage } from './pages/app/GeneratedDocumentDetailPage';
import { InvoicesPage } from './pages/app/InvoicesPage';
import { DepositsSettlementsPage } from './pages/app/DepositsSettlementsPage';
import { MemberPayoutsPage } from './pages/app/MemberPayoutsPage';
// Public pages (standalone)
import { PublicArtistBookingPage } from './pages/public/PublicArtistBookingPage';
import { PublicVenueProfilePage } from './pages/public/PublicVenueProfilePage';
import { PublicFormPage } from './pages/public/PublicFormPage';
import { InquiryThanksPage } from './pages/public/InquiryThanksPage';
import { PaymentLinkPage } from './pages/public/PaymentLinkPage';
import { PaymentSuccessPage } from './pages/public/PaymentSuccessPage';
import { UnsubscribePage } from './pages/public/UnsubscribePage';
import { SharedItineraryPage } from './pages/public/SharedItineraryPage';
import { SharedOfferPage } from './pages/public/SharedOfferPage';
// Admin pages (standalone)
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { AdminApprovalsPage } from './pages/admin/AdminApprovalsPage';
import { AdminAuditLogPage } from './pages/admin/AdminAuditLogPage';
import { AdminVenueClaimsPage } from './pages/admin/AdminVenueClaimsPage';
import { AdminDataVerificationPage } from './pages/admin/AdminDataVerificationPage';
import { AdminImportExportPage } from './pages/admin/AdminImportExportPage';
import { AdminCompliancePage } from './pages/admin/AdminCompliancePage';
import { AdminBrandingPage } from './pages/admin/AdminBrandingPage';
import { AdminIntegrationsHealthPage } from './pages/admin/AdminIntegrationsHealthPage';
import { AdminEmbedBuilderPage } from './pages/admin/AdminEmbedBuilderPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        {/* ═══════════════════════════════════════════ */}
        {/* Marketing pages (wrapped in MarketingLayout) */}
        {/* ═══════════════════════════════════════════ */}
        <Route path="/" element={<MarketingLayout data-id="element-4">
              <HomePage data-id="element-5" />
            </MarketingLayout>} data-id="element-3" />
        <Route path="/product" element={<MarketingLayout data-id="element-7">
              <ProductOverviewPage data-id="element-8" />
            </MarketingLayout>} data-id="element-6" />
        <Route path="/pricing" element={<MarketingLayout data-id="element-10">
              <PricingPage data-id="element-11" />
            </MarketingLayout>} data-id="element-9" />
        <Route path="/discovery" element={<MarketingLayout data-id="element-13">
              <DiscoveryRoutingPage data-id="element-14" />
            </MarketingLayout>} data-id="element-12" />
        <Route path="/deals-contracts" element={<MarketingLayout data-id="element-16">
              <DealsContractsPage data-id="element-17" />
            </MarketingLayout>} data-id="element-15" />
        <Route path="/lineup-ops" element={<MarketingLayout data-id="element-19">
              <LineupTourOpsPage data-id="element-20" />
            </MarketingLayout>} data-id="element-18" />
        <Route path="/ai-assistant" element={<MarketingLayout data-id="element-22">
              <AIAssistantPage data-id="element-23" />
            </MarketingLayout>} data-id="element-21" />
        <Route path="/security" element={<MarketingLayout data-id="element-25">
              <SecurityPage data-id="element-26" />
            </MarketingLayout>} data-id="element-24" />
        <Route path="/demo" element={<MarketingLayout data-id="element-28">
              <DemoPage data-id="element-29" />
            </MarketingLayout>} data-id="element-27" />
        <Route path="/contact" element={<MarketingLayout data-id="element-31">
              <ContactPage data-id="element-32" />
            </MarketingLayout>} data-id="element-30" />
        <Route path="/contact-sales" element={<MarketingLayout data-id="element-34">
              <ContactSalesPage data-id="element-35" />
            </MarketingLayout>} data-id="element-33" />
        <Route path="/thank-you" element={<MarketingLayout data-id="element-37">
              <ThankYouPage data-id="element-38" />
            </MarketingLayout>} data-id="element-36" />
        <Route path="/for-artists" element={<MarketingLayout data-id="element-40">
              <ForArtistsPage data-id="element-41" />
            </MarketingLayout>} data-id="element-39" />
        <Route path="/for-venues" element={<MarketingLayout data-id="element-43">
              <ForVenuesPage data-id="element-44" />
            </MarketingLayout>} data-id="element-42" />
        <Route path="/for-agents" element={<MarketingLayout data-id="element-46">
              <ForAgentsPage data-id="element-47" />
            </MarketingLayout>} data-id="element-45" />
        <Route path="/terms" element={<MarketingLayout data-id="element-49">
              <TermsPage data-id="element-50" />
            </MarketingLayout>} data-id="element-48" />
        <Route path="/privacy" element={<MarketingLayout data-id="element-52">
              <PrivacyPage data-id="element-53" />
            </MarketingLayout>} data-id="element-51" />
        <Route path="/faq" element={<MarketingLayout data-id="element-55">
              <FAQPage data-id="element-56" />
            </MarketingLayout>} data-id="element-54" />
        <Route path="/use-cases" element={<MarketingLayout data-id="element-58">
              <UseCasesHubPage data-id="element-59" />
            </MarketingLayout>} data-id="element-57" />
        <Route path="/use-cases/plan-a-regional-tour" element={<MarketingLayout data-id="element-61">
              <PlanRegionalTourPage data-id="element-62" />
            </MarketingLayout>} data-id="element-60" />
        <Route path="/use-cases/fill-an-open-date-fast" element={<MarketingLayout data-id="element-64">
              <FillOpenDatePage data-id="element-65" />
            </MarketingLayout>} data-id="element-63" />
        <Route path="/use-cases/run-a-roster-without-chaos" element={<MarketingLayout data-id="element-67">
              <RunRosterPage data-id="element-68" />
            </MarketingLayout>} data-id="element-66" />
        <Route path="/use-cases/lock-the-lineup-before-you-lock-the-show" element={<MarketingLayout data-id="element-70">
              <LockLineupPage data-id="element-71" />
            </MarketingLayout>} data-id="element-69" />
        <Route path="/use-cases/offer-to-deposit-to-confirmed-show" element={<MarketingLayout data-id="element-73">
              <OfferToDepositPage data-id="element-74" />
            </MarketingLayout>} data-id="element-72" />
        <Route path="/use-cases/manage-the-show-after-its-booked" element={<MarketingLayout data-id="element-76">
              <ManageShowPage data-id="element-77" />
            </MarketingLayout>} data-id="element-75" />
        <Route path="/use-cases/operate-booker-in-plain-language" element={<MarketingLayout data-id="element-79">
              <OperatePlainLanguagePage data-id="element-80" />
            </MarketingLayout>} data-id="element-78" />

        {/* ═══════════════════════════════════════════ */}
        {/* Auth pages (standalone, no layout wrapper) */}
        {/* ═══════════════════════════════════════════ */}
        <Route path="/login" element={<LoginPage data-id="element-82" />} data-id="element-81" />
        <Route path="/signup" element={<SignupPage data-id="element-84" />} data-id="element-83" />
        <Route path="/invite" element={<AcceptInvitePage data-id="element-86" />} data-id="element-85" />
        <Route path="/verify-email" element={<VerifyEmailPage data-id="element-88" />} data-id="element-87" />
        <Route path="/forgot-password" element={<ForgotPasswordPage data-id="element-90" />} data-id="element-89" />
        <Route path="/reset-password" element={<ResetPasswordPage data-id="element-92" />} data-id="element-91" />
        <Route path="/setup-2fa" element={<Setup2FAPage data-id="element-94" />} data-id="element-93" />
        <Route path="/workspace-select" element={<WorkspaceSelectPage data-id="element-96" />} data-id="element-95" />
        <Route path="/plan-select" element={<PlanSelectPage data-id="element-98" />} data-id="element-97" />
        <Route path="/checkout" element={<CheckoutPage data-id="element-100" />} data-id="element-99" />
        <Route path="/account/profile" element={<AccountProfilePage data-id="element-102" />} data-id="element-101" />
        <Route path="/account/preferences" element={<AccountPreferencesPage data-id="element-104" />} data-id="element-103" />

        {/* Onboarding (standalone) */}
        <Route path="/onboarding" element={<OnboardingPage data-id="element-106" />} data-id="element-105" />

        {/* ═══════════════════════════════════════════ */}
        {/* App pages (wrapped in AppLayout) */}
        {/* Note: specific routes before dynamic :param routes */}
        {/* ═══════════════════════════════════════════ */}
        <Route path="/app" element={<AppLayout data-id="element-108">
              <DashboardPage data-id="element-109" />
            </AppLayout>} data-id="element-107" />
        <Route path="/app/notifications" element={<AppLayout data-id="element-111">
              <NotificationsPage data-id="element-112" />
            </AppLayout>} data-id="element-110" />
        <Route path="/app/roster" element={<AppLayout data-id="element-114">
              <RosterPage data-id="element-115" />
            </AppLayout>} data-id="element-113" />
        <Route path="/app/campaigns/new" element={<AppLayout data-id="element-117">
              <CampaignNewPage data-id="element-118" />
            </AppLayout>} data-id="element-116" />
        <Route path="/app/campaigns/:id" element={<AppLayout data-id="element-120">
              <CampaignDetailPage data-id="element-121" />
            </AppLayout>} data-id="element-119" />
        <Route path="/app/campaigns" element={<AppLayout data-id="element-123">
              <CampaignsPage data-id="element-124" />
            </AppLayout>} data-id="element-122" />
        <Route path="/app/venues/:venueId" element={<AppLayout data-id="element-126">
              <VenueDetailPage data-id="element-127" />
            </AppLayout>} data-id="element-125" />
        <Route path="/app/venues" element={<AppLayout data-id="element-129">
              <VenuesPage data-id="element-130" />
            </AppLayout>} data-id="element-128" />
        <Route path="/app/venue-profile" element={<AppLayout data-id="element-132">
              <VenueProfilePage data-id="element-133" />
            </AppLayout>} data-id="element-131" />
        <Route path="/app/inbox" element={<AppLayout data-id="element-135">
              <InboxPage data-id="element-136" />
            </AppLayout>} data-id="element-134" />
        <Route path="/app/deals/:id" element={<AppLayout data-id="element-138">
              <DealDetailPage data-id="element-139" />
            </AppLayout>} data-id="element-137" />
        <Route path="/app/deals" element={<AppLayout data-id="element-141">
              <DealsPage data-id="element-142" />
            </AppLayout>} data-id="element-140" />
        <Route path="/app/schedule" element={<AppLayout data-id="element-144">
              <SchedulePage data-id="element-145" />
            </AppLayout>} data-id="element-143" />
        <Route path="/app/lineup" element={<AppLayout data-id="element-147">
              <LineupPage data-id="element-148" />
            </AppLayout>} data-id="element-146" />
        <Route path="/app/shows/:id" element={<AppLayout data-id="element-150">
              <ShowDetailPage data-id="element-151" />
            </AppLayout>} data-id="element-149" />
        <Route path="/app/shows" element={<AppLayout data-id="element-153">
              <ShowsPage data-id="element-154" />
            </AppLayout>} data-id="element-152" />
        <Route path="/app/analytics" element={<AppLayout data-id="element-156">
              <AnalyticsPage data-id="element-157" />
            </AppLayout>} data-id="element-155" />
        <Route path="/app/assets" element={<AppLayout data-id="element-159">
              <AssetsPage data-id="element-160" />
            </AppLayout>} data-id="element-158" />
        <Route path="/app/settings" element={<AppLayout data-id="element-162">
              <SettingsPage data-id="element-163" />
            </AppLayout>} data-id="element-161" />
        <Route path="/app/profile" element={<AppLayout data-id="element-165">
              <ArtistProfilePage data-id="element-166" />
            </AppLayout>} data-id="element-164" />
        <Route path="/app/contracts/templates/builder" element={<AppLayout data-id="element-168">
              <ContractTemplateBuilderPage data-id="element-169" />
            </AppLayout>} data-id="element-167" />
        <Route path="/app/contracts" element={<AppLayout data-id="element-171">
              <ContractsPage data-id="element-172" />
            </AppLayout>} data-id="element-170" />
        <Route path="/app/payments" element={<AppLayout data-id="element-174">
              <PaymentsPage data-id="element-175" />
            </AppLayout>} data-id="element-173" />
        <Route path="/app/invoices" element={<AppLayout data-id="element-177">
              <InvoicesPage data-id="element-178" />
            </AppLayout>} data-id="element-176" />
        <Route path="/app/deposits-settlements" element={<AppLayout data-id="element-180">
              <DepositsSettlementsPage data-id="element-181" />
            </AppLayout>} data-id="element-179" />
        <Route path="/app/payouts" element={<AppLayout data-id="element-183">
              <MemberPayoutsPage data-id="element-184" />
            </AppLayout>} data-id="element-182" />
        <Route path="/app/team" element={<AppLayout data-id="element-186">
              <TeamPage data-id="element-187" />
            </AppLayout>} data-id="element-185" />
        <Route path="/app/event-needs/new" element={<AppLayout data-id="element-189">
              <EventNeedNewPage data-id="element-190" />
            </AppLayout>} data-id="element-188" />
        <Route path="/app/event-needs/:eventNeedId" element={<AppLayout data-id="element-192">
              <EventNeedDetailPage data-id="element-193" />
            </AppLayout>} data-id="element-191" />
        <Route path="/app/event-needs" element={<AppLayout data-id="element-195">
              <EventNeedsPage data-id="element-196" />
            </AppLayout>} data-id="element-194" />
        <Route path="/app/artist-search" element={<AppLayout data-id="element-198">
              <ArtistSearchPage data-id="element-199" />
            </AppLayout>} data-id="element-197" />
        <Route path="/app/artists/:artistId/members/:memberId" element={<AppLayout data-id="element-201">
              <MemberDetailPage data-id="element-202" />
            </AppLayout>} data-id="element-200" />
        <Route path="/app/documents/:documentId" element={<AppLayout data-id="element-204">
              <GeneratedDocumentDetailPage data-id="element-205" />
            </AppLayout>} data-id="element-203" />

        {/* ═══════════════════════════════════════════ */}
        {/* Public pages (standalone, no layout) */}
        {/* ═══════════════════════════════════════════ */}
        <Route path="/book/:artistSlug" element={<PublicArtistBookingPage data-id="element-207" />} data-id="element-206" />
        <Route path="/venue/:venueSlug" element={<PublicVenueProfilePage data-id="element-209" />} data-id="element-208" />
        <Route path="/form/:formId" element={<PublicFormPage data-id="element-211" />} data-id="element-210" />
        <Route path="/inquiry/thanks" element={<InquiryThanksPage data-id="element-213" />} data-id="element-212" />
        <Route path="/pay/success" element={<PaymentSuccessPage data-id="element-215" />} data-id="element-214" />
        <Route path="/pay/:paymentId" element={<PaymentLinkPage data-id="element-217" />} data-id="element-216" />
        <Route path="/unsubscribe" element={<UnsubscribePage data-id="element-219" />} data-id="element-218" />
        <Route path="/itinerary/:itineraryId" element={<SharedItineraryPage data-id="element-221" />} data-id="element-220" />
        <Route path="/offer/:offerId" element={<SharedOfferPage data-id="element-223" />} data-id="element-222" />

        {/* ═══════════════════════════════════════════ */}
        {/* Admin pages (standalone, own layout) */}
        {/* ═══════════════════════════════════════════ */}
        <Route path="/admin" element={<AdminDashboardPage data-id="element-225" />} data-id="element-224" />
        <Route path="/admin/approvals" element={<AdminApprovalsPage data-id="element-227" />} data-id="element-226" />
        <Route path="/admin/audit-log" element={<AdminAuditLogPage data-id="element-229" />} data-id="element-228" />
        <Route path="/admin/venue-claims" element={<AdminVenueClaimsPage data-id="element-231" />} data-id="element-230" />
        <Route path="/admin/data-verification" element={<AdminDataVerificationPage data-id="element-233" />} data-id="element-232" />
        <Route path="/admin/import-export" element={<AdminImportExportPage data-id="element-235" />} data-id="element-234" />
        <Route path="/admin/compliance" element={<AdminCompliancePage data-id="element-237" />} data-id="element-236" />
        <Route path="/admin/branding" element={<AdminBrandingPage data-id="element-239" />} data-id="element-238" />
        <Route path="/admin/integrations" element={<AdminIntegrationsHealthPage data-id="element-241" />} data-id="element-240" />
        <Route path="/admin/embed-builder" element={<AdminEmbedBuilderPage data-id="element-243" />} data-id="element-242" />

        {/* ═══════════════════════════════════════════ */}
        {/* System / Error pages */}
        {/* ═══════════════════════════════════════════ */}
        <Route path="/403" element={<ForbiddenPage data-id="element-245" />} data-id="element-244" />
        <Route path="/500" element={<ServerErrorPage data-id="element-247" />} data-id="element-246" />
        <Route path="/maintenance" element={<MaintenancePage data-id="element-249" />} data-id="element-248" />

        {/* 404 catch-all — must be last */}
        <Route path="*" element={<NotFoundPage data-id="element-251" />} data-id="element-250" />
      </Routes>
    </BrowserRouter>;
}